module.exports = __webpack_public_path__ + "img/bk_19_01.890f0338.png";